class BackToTop extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.button = this.querySelector('[data-button]');
    this.scrollOffset = window.innerHeight / 2;

    this.toggleVisibility();

    this.onButtonClickListener = this.onButtonClick.bind(this);
    this.button.addEventListener('click', this.onButtonClickListener);

    this.onScrollListener = this.toggleVisibility.bind(this);
    window.addEventListener('scroll', this.onScrollListener);
  }

  disconnectedCallback() {
    this.button.removeEventListener('click', this.onButtonClickListener);
    window.removeEventListener('scroll', this.onScrollListener);
  }

  onButtonClick(e) {
    e.preventDefault();

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }

  toggleVisibility() {
    this.classList.toggle('is-visible', window.scrollY >= this.scrollOffset);
  }
}

customElements.define('back-to-top', BackToTop);
